import { casApi as api } from "./casApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getApiAuthCheckSession: build.query<
      GetApiAuthCheckSessionApiResponse,
      GetApiAuthCheckSessionApiArg
    >({
      query: () => ({ url: `/api/auth/check-session` }),
    }),
    getApiV2AuthOrgByOrgIdCheckSession: build.query<
      GetApiV2AuthOrgByOrgIdCheckSessionApiResponse,
      GetApiV2AuthOrgByOrgIdCheckSessionApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/auth/org/${queryArg.orgId}/check-session`,
      }),
    }),
    postApiAuthForgotPassword: build.mutation<
      PostApiAuthForgotPasswordApiResponse,
      PostApiAuthForgotPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/forgot-password`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiAuthLogin: build.mutation<
      PostApiAuthLoginApiResponse,
      PostApiAuthLoginApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/login`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiAuthLogout: build.mutation<
      PostApiAuthLogoutApiResponse,
      PostApiAuthLogoutApiArg
    >({
      query: () => ({ url: `/api/auth/logout`, method: "POST" }),
    }),
    postApiAuthRefreshToken: build.mutation<
      PostApiAuthRefreshTokenApiResponse,
      PostApiAuthRefreshTokenApiArg
    >({
      query: () => ({ url: `/api/auth/refresh-token`, method: "POST" }),
    }),
    postApiV2AuthOrgByOrgIdRefreshToken: build.mutation<
      PostApiV2AuthOrgByOrgIdRefreshTokenApiResponse,
      PostApiV2AuthOrgByOrgIdRefreshTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v2/auth/org/${queryArg.orgId}/refresh-token`,
        method: "POST",
      }),
    }),
    postApiAuthResetPassword: build.mutation<
      PostApiAuthResetPasswordApiResponse,
      PostApiAuthResetPasswordApiArg
    >({
      query: (queryArg) => ({
        url: `/api/auth/reset-password`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getApiDevelopmentFunctionalityAssignments: build.query<
      GetApiDevelopmentFunctionalityAssignmentsApiResponse,
      GetApiDevelopmentFunctionalityAssignmentsApiArg
    >({
      query: () => ({ url: `/api/development/functionality-assignments` }),
    }),
    getApiRentersMyRoles: build.query<
      GetApiRentersMyRolesApiResponse,
      GetApiRentersMyRolesApiArg
    >({
      query: () => ({ url: `/api/renters/my-roles` }),
    }),
    getApiTenantsByTenantIdUsers: build.query<
      GetApiTenantsByTenantIdUsersApiResponse,
      GetApiTenantsByTenantIdUsersApiArg
    >({
      query: (queryArg) => ({
        url: `/api/tenants/${queryArg.tenantId}/users`,
        params: {
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiUsersAssignmentsByUserId: build.mutation<
      PostApiUsersAssignmentsByUserIdApiResponse,
      PostApiUsersAssignmentsByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/assignments/${queryArg.userId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiUsersAssignmentsByUserId: build.mutation<
      DeleteApiUsersAssignmentsByUserIdApiResponse,
      DeleteApiUsersAssignmentsByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/assignments/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    patchApiUsersAssignmentsByUserId: build.mutation<
      PatchApiUsersAssignmentsByUserIdApiResponse,
      PatchApiUsersAssignmentsByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/assignments/${queryArg.userId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiUsersChangePasswordByUserId: build.mutation<
      PatchApiUsersChangePasswordByUserIdApiResponse,
      PatchApiUsersChangePasswordByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/change-password/${queryArg.userId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postApiUsersChangeOrganizationRoleByUserId: build.mutation<
      PostApiUsersChangeOrganizationRoleByUserIdApiResponse,
      PostApiUsersChangeOrganizationRoleByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/change-organization-role/${queryArg.userId}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiUsersByUserId: build.mutation<
      DeleteApiUsersByUserIdApiResponse,
      DeleteApiUsersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    getApiUsersByUserId: build.query<
      GetApiUsersByUserIdApiResponse,
      GetApiUsersByUserIdApiArg
    >({
      query: (queryArg) => ({ url: `/api/users/${queryArg.userId}` }),
    }),
    patchApiUsersByUserId: build.mutation<
      PatchApiUsersByUserIdApiResponse,
      PatchApiUsersByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/${queryArg.userId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    getApiUsersMyOrganization: build.query<
      GetApiUsersMyOrganizationApiResponse,
      GetApiUsersMyOrganizationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/my-organization`,
        params: {
          organizationId: queryArg.organizationId,
        },
      }),
    }),
    getApiUsersMyRoles: build.query<
      GetApiUsersMyRolesApiResponse,
      GetApiUsersMyRolesApiArg
    >({
      query: () => ({ url: `/api/users/my-roles` }),
    }),
    getApiUsersInvitationByInvitationToken: build.query<
      GetApiUsersInvitationByInvitationTokenApiResponse,
      GetApiUsersInvitationByInvitationTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/invitation/${queryArg.invitationToken}`,
      }),
    }),
    getApiUsersAutocomplete: build.query<
      GetApiUsersAutocompleteApiResponse,
      GetApiUsersAutocompleteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/autocomplete`,
        params: {
          TenantIds: queryArg.tenantIds,
          Name: queryArg.name,
          Email: queryArg.email,
          Take: queryArg.take,
        },
      }),
    }),
    getApiUsers: build.query<GetApiUsersApiResponse, GetApiUsersApiArg>({
      query: (queryArg) => ({
        url: `/api/users`,
        params: {
          OrganizationId: queryArg.organizationId,
          TenantId: queryArg.tenantId,
          UserRoles: queryArg.userRoles,
          UserState: queryArg.userState,
          Query: queryArg.query,
          Comment: queryArg.comment,
          "Sort.SortOption": queryArg["Sort.SortOption"],
          "Sort.Direction": queryArg["Sort.Direction"],
          IsGlobalUserPage: queryArg.isGlobalUserPage,
          OrganizationRoles: queryArg.organizationRoles,
          Page: queryArg.page,
          PageSize: queryArg.pageSize,
        },
      }),
    }),
    postApiUsersInvite: build.mutation<
      PostApiUsersInviteApiResponse,
      PostApiUsersInviteApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/invite`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiUsersInviteGlobal: build.mutation<
      PostApiUsersInviteGlobalApiResponse,
      PostApiUsersInviteGlobalApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/invite-global`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postApiUsersRegisterByInvitationToken: build.mutation<
      PostApiUsersRegisterByInvitationTokenApiResponse,
      PostApiUsersRegisterByInvitationTokenApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/register/${queryArg.invitationToken}`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    deleteApiUsersAssignmentsByTenantIdRemoveAndUserId: build.mutation<
      DeleteApiUsersAssignmentsByTenantIdRemoveAndUserIdApiResponse,
      DeleteApiUsersAssignmentsByTenantIdRemoveAndUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/assignments/${queryArg.tenantId}/remove/${queryArg.userId}`,
        method: "DELETE",
      }),
    }),
    patchApiUsersActiveByUserId: build.mutation<
      PatchApiUsersActiveByUserIdApiResponse,
      PatchApiUsersActiveByUserIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/active/${queryArg.userId}`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    patchApiUsersProfile: build.mutation<
      PatchApiUsersProfileApiResponse,
      PatchApiUsersProfileApiArg
    >({
      query: (queryArg) => ({
        url: `/api/users/profile`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedCas };
export type GetApiAuthCheckSessionApiResponse =
  /** status 200 OK */ CheckSessionResponse;
export type GetApiAuthCheckSessionApiArg = void;
export type GetApiV2AuthOrgByOrgIdCheckSessionApiResponse =
  /** status 200 OK */ CheckSessionResponse;
export type GetApiV2AuthOrgByOrgIdCheckSessionApiArg = {
  orgId: string;
};
export type PostApiAuthForgotPasswordApiResponse = unknown;
export type PostApiAuthForgotPasswordApiArg = {
  body: CreatePasswordRecoveryTokenRequest;
};
export type PostApiAuthLoginApiResponse =
  /** status 200 OK */ AuthenticatedResponse;
export type PostApiAuthLoginApiArg = {
  body: LoginRequest;
};
export type PostApiAuthLogoutApiResponse = unknown;
export type PostApiAuthLogoutApiArg = void;
export type PostApiAuthRefreshTokenApiResponse =
  /** status 200 OK */ AuthenticatedResponse;
export type PostApiAuthRefreshTokenApiArg = void;
export type PostApiV2AuthOrgByOrgIdRefreshTokenApiResponse =
  /** status 200 OK */ AuthenticatedResponse;
export type PostApiV2AuthOrgByOrgIdRefreshTokenApiArg = {
  orgId: string;
};
export type PostApiAuthResetPasswordApiResponse = unknown;
export type PostApiAuthResetPasswordApiArg = {
  body: ResetPasswordRequest;
};
export type GetApiDevelopmentFunctionalityAssignmentsApiResponse =
  /** status 200 OK */ FunctionalityAssignmentsResponse[];
export type GetApiDevelopmentFunctionalityAssignmentsApiArg = void;
export type GetApiRentersMyRolesApiResponse =
  /** status 200 OK */ RenterRoleDetails;
export type GetApiRentersMyRolesApiArg = void;
export type GetApiTenantsByTenantIdUsersApiResponse =
  /** status 200 OK */ TenantUserReadModelPagedListResult;
export type GetApiTenantsByTenantIdUsersApiArg = {
  tenantId: string;
  page: number;
  pageSize: number;
};
export type PostApiUsersAssignmentsByUserIdApiResponse = unknown;
export type PostApiUsersAssignmentsByUserIdApiArg = {
  userId: string;
  body: AssignTenantUserRequest;
};
export type DeleteApiUsersAssignmentsByUserIdApiResponse = unknown;
export type DeleteApiUsersAssignmentsByUserIdApiArg = {
  userId: string;
};
export type PatchApiUsersAssignmentsByUserIdApiResponse =
  /** status 200 OK */ UserGlobalReadModel;
export type PatchApiUsersAssignmentsByUserIdApiArg = {
  userId: string;
  body: UpdateUserAssignmentsRequest;
};
export type PatchApiUsersChangePasswordByUserIdApiResponse = unknown;
export type PatchApiUsersChangePasswordByUserIdApiArg = {
  userId: string;
  body: ChangePasswordUserRequest;
};
export type PostApiUsersChangeOrganizationRoleByUserIdApiResponse =
  /** status 200 OK */ ChangeUserOrganizationRoleResponse;
export type PostApiUsersChangeOrganizationRoleByUserIdApiArg = {
  userId: string;
  body: ChangeUserOrganizationRoleRequest;
};
export type DeleteApiUsersByUserIdApiResponse = unknown;
export type DeleteApiUsersByUserIdApiArg = {
  userId: string;
};
export type GetApiUsersByUserIdApiResponse =
  /** status 200 OK */ UserGlobalReadModel;
export type GetApiUsersByUserIdApiArg = {
  userId: string;
};
export type PatchApiUsersByUserIdApiResponse =
  /** status 200 OK */ UserGlobalReadModel;
export type PatchApiUsersByUserIdApiArg = {
  userId: string;
  body: UpdateUserRequest;
};
export type GetApiUsersMyOrganizationApiResponse =
  /** status 200 OK */ OrganizationContext;
export type GetApiUsersMyOrganizationApiArg = {
  organizationId?: string;
};
export type GetApiUsersMyRolesApiResponse =
  /** status 200 OK */ UserRoleDetails;
export type GetApiUsersMyRolesApiArg = void;
export type GetApiUsersInvitationByInvitationTokenApiResponse =
  /** status 200 OK */ UserInvitationReadModel;
export type GetApiUsersInvitationByInvitationTokenApiArg = {
  invitationToken: string;
};
export type GetApiUsersAutocompleteApiResponse =
  /** status 200 OK */ UserAutocompleteResponse[];
export type GetApiUsersAutocompleteApiArg = {
  tenantIds?: string[];
  name?: string;
  email?: string;
  take?: number;
};
export type GetApiUsersApiResponse =
  /** status 200 OK */ UserGlobalReadModelPagedListResult;
export type GetApiUsersApiArg = {
  organizationId?: string;
  tenantId?: string;
  userRoles?: UserRole[];
  userState?: UserState;
  query?: string;
  comment?: string;
  "Sort.SortOption"?: SortGlobalUserQueryOptions;
  "Sort.Direction"?: SortDirection;
  isGlobalUserPage?: boolean;
  organizationRoles?: UserOrganizationRole[];
  page: number;
  pageSize: number;
};
export type PostApiUsersInviteApiResponse = /** status 200 OK */ string;
export type PostApiUsersInviteApiArg = {
  body: InviteUserRequest;
};
export type PostApiUsersInviteGlobalApiResponse = /** status 200 OK */ string;
export type PostApiUsersInviteGlobalApiArg = {
  body: InviteUserGlobalRequest;
};
export type PostApiUsersRegisterByInvitationTokenApiResponse =
  /** status 200 OK */ AuthenticatedResponse;
export type PostApiUsersRegisterByInvitationTokenApiArg = {
  invitationToken: string;
  body: RegisterUserRequest;
};
export type DeleteApiUsersAssignmentsByTenantIdRemoveAndUserIdApiResponse =
  unknown;
export type DeleteApiUsersAssignmentsByTenantIdRemoveAndUserIdApiArg = {
  userId: string;
  tenantId: string;
};
export type PatchApiUsersActiveByUserIdApiResponse = unknown;
export type PatchApiUsersActiveByUserIdApiArg = {
  userId: string;
  body: UpdateUserActiveRequest;
};
export type PatchApiUsersProfileApiResponse =
  /** status 200 OK */ UserDetailReadModel;
export type PatchApiUsersProfileApiArg = {
  body: UpdateUserProfileRequest;
};
export type UserOrganizationRole = "Admin" | "Regular" | "SuperAdmin";
export type UserInfoResponse = {
  id: string;
  organizationId?: null | string;
  organizationRole?: UserOrganizationRole;
  email: string;
  firstName: string;
  lastName: string;
  organizationName?: null | string;
};
export type UserRole =
  | "Technician"
  | "Regular"
  | "Admin"
  | "SuperAdmin"
  | "Customer"
  | "Kerlink"
  | "BuildingManager"
  | "AssetManager";
export type AllowedTenantResponse = {
  id: string;
  orgId: string;
  name: string;
  role: UserRole;
};
export type Functionality =
  | "UserAuthentication"
  | "SystemProcess"
  | "AnonymousAccess"
  | "InstallToolAccess"
  | "AdminAppAccess"
  | "ZipCodesView"
  | "TemplateFilesView"
  | "DevelopmentSectionView"
  | "DeviceLifecycleFilterView"
  | "ProductionLineView"
  | "HeatingClampsView"
  | "HeatingClampsManagement"
  | "ApplicationSettingsView"
  | "ApplicationSettingsManagement"
  | "ArtifactStoreView"
  | "ArtifactStoreManagement"
  | "FirmwareUpdateView"
  | "FirmwareUpdateManagement"
  | "ThermostatDownlinksManagement"
  | "DeviceOnboardingManagement"
  | "DataTransferToDeviceBatchView"
  | "DataTransferToDeviceBatchManagement"
  | "GatewaysView"
  | "GatewaysListView"
  | "GatewaysGlobalListExport"
  | "GatewaysAssign"
  | "GatewaysAdd"
  | "GatewaysDelete"
  | "GatewaysUpdate"
  | "GatewaysTenantReassign"
  | "SensorsView"
  | "SensorsAssign"
  | "SensorsAdd"
  | "SensorsDelete"
  | "SensorsUpdate"
  | "SensorsConfigure"
  | "SignalTesterView"
  | "SignalTesterUpdate"
  | "ThermostatsView"
  | "ThermostatsDetails"
  | "ThermostatsAssign"
  | "ThermostatsAdd"
  | "ThermostatsDelete"
  | "ThermostatsUpdate"
  | "ThermostatsGlobalListView"
  | "ThermostatsGlobalListExport"
  | "ThermostatsLifecycleManagement"
  | "ThermostatSidebarMeasurementsView"
  | "ThermostatsStallDetection"
  | "ThermostatsFirmwareUpdate"
  | "ThermostatsActions"
  | "ThermostatsTenantReassign"
  | "ThermostatMcuReset"
  | "ThermostatValveFlush"
  | "ThermostatSidebarHistoryEventsView"
  | "ThermostatSidebarHistoryDownlinksView"
  | "ThermostatSidebarProductionView"
  | "ThermostatActiveHarvesting"
  | "ThermostatInternalBinaries"
  | "ThermostatReportMalfunction"
  | "ThermostatSidebarGrafanaLinkView"
  | "HeatLoadCalculationView"
  | "HeatLoadCalculationManagement"
  | "TaxonomyInstallToolView"
  | "TaxonomyView"
  | "TaxonomyEditorView"
  | "TaxonomyRename"
  | "TaxonomyExport"
  | "TaxonomyImport"
  | "LocationsManagement"
  | "BuildingComplexesManagement"
  | "BuildingsAdd"
  | "BuildingsRemove"
  | "BuildingsUpdate"
  | "BuildingUnitsAdd"
  | "BuildingUnitsRemove"
  | "BuildingUnitsUpdate"
  | "RoomsManagement"
  | "RadiatorsManagement"
  | "HeatingCircuitsManagement"
  | "HeatingChainView"
  | "FloorsManagement"
  | "WindowsManagement"
  | "HydraulicBalancingManagement"
  | "RentersLeasesView"
  | "RentersLeasesManagement"
  | "RentersLeaseDelete"
  | "AppointmentsView"
  | "AppointmentsManagement"
  | "RentersVerificationsView"
  | "RentersVerificationsOverride"
  | "RentersImport"
  | "RentersBulkUpdate"
  | "OrganizationAdd"
  | "OrganizationList"
  | "OrganizationEdit"
  | "OrganizationEditOther"
  | "IsAdminInAllOrganizationTenants"
  | "TenantsView"
  | "TenantAdd"
  | "TenantUpdate"
  | "TenantsManagement"
  | "UsersView"
  | "UsersAdd"
  | "UsersUpdate"
  | "UsersUpdateActive"
  | "UsersDelete"
  | "UsersAssign"
  | "UserCommentManagement"
  | "UsersProfileManagement"
  | "UsersSuperAdminView"
  | "UsersChangeOrganizationRole"
  | "UsersIsSuperAdmin"
  | "UsersCanSeeOrgUsers"
  | "AlertsView"
  | "DataPrivacyView"
  | "DataPrivacyManagement"
  | "OptInView"
  | "OptInManagement"
  | "LegalNoteView"
  | "LegalNoteManagement"
  | "TermsOfUseView"
  | "TermsOfUseManagement"
  | "DataProtectionAgreementAdd"
  | "DataProtectionAgreementUpdate"
  | "UsersOptInAgreementView"
  | "UsersOptInAgreementAdd"
  | "UsersOptInAgreementUpdate"
  | "ProjectsView"
  | "ProjectsDetailView"
  | "ProjectsUserView"
  | "ProjectRenterAgreementView"
  | "ProjectsManagement"
  | "ProjectsDelete"
  | "ProjectsExport"
  | "ApartmentThermostatsView"
  | "ApartmentSpaceRename"
  | "DownloadRenterUnitData"
  | "RenowateView"
  | "RenowateManage"
  | "ImagesView"
  | "AuthBackofficeProcess"
  | "AuthUserProcess"
  | "ThermostatService_AssemblyLineHealthCheck"
  | "ThermostatService_CreateKeys"
  | "ThermostatService_Provisioning"
  | "ThermostatService_UploadAssemblyLogs"
  | "ThermostatService_ManualDeviceLifecycle"
  | "ThermostatService_DirectThermostatDownlink"
  | "ThermostatService_ArtifactStore"
  | "ThermostatService_DataTransferToDevice"
  | "ThermostatService_DataTransferFromDevice"
  | "ThermostatService_Operations"
  | "ThermostatService_TargetTemperatureOperations"
  | "HydraulicBalancing_ManageProcess"
  | "Ingestion_RawQuery"
  | "Ingestion_UploadAssemblyLineLog"
  | "Ingestion_AssemblyLineHistory"
  | "Ingestion_AssemblyLineSummaryExport"
  | "Ingestion_AssemblyLineDetailExport"
  | "Ingestion_ThermostatMeasurementsExport"
  | "Ingestion_ThermostatMeasurements"
  | "HeatingAuthority_SetManualTargetTemperature"
  | "HeatingAuthority_ManageHeatingClamps"
  | "HeatingAuthority_ManageHeatPlans"
  | "ApartmentMembersManagement"
  | "ApartmentMembershipLeave"
  | "ApartmentMembersView"
  | "ApartmentMembershipDisconnect"
  | "PortfolioView"
  | "NonResidentialTaxonomyView"
  | "HeatingAuthority_ScheduleRenterCommand"
  | "ApartmentThermostatsControl"
  | "HeatingAuthority_ReadRenterCommandState"
  | "NonResidentialHeatingPlansManagement"
  | "NonResidentialHeatingPlanAssignmentsManagement"
  | "NonResidentialHeatingTemperaturesManagement"
  | "NonResidentialActivityView";
export type FunctionalityAssignment = {
  role: UserRole;
  functionalities: Functionality[];
};
export type UserOrganizationAuth = {
  organizationId?: null | string;
  organizationRole: UserOrganizationRole;
  organizationPermissions?: null | Functionality[];
  roleInAllTenants?: UserRole;
  permissionInAllTenants?: null | Functionality[];
};
export type CheckSessionResponse = {
  user: UserInfoResponse;
  allowedTenants: AllowedTenantResponse[];
  assignedFunctionalities: FunctionalityAssignment[];
  organizationAuth?: UserOrganizationAuth;
};
export type ProblemDetails = {
  type?: null | string;
  title?: null | string;
  status?: null | number;
  detail?: null | string;
  instance?: null | string;
  [key: string]: any;
};
export type CreatePasswordRecoveryTokenRequest = {
  email: string;
};
export type TokenResult = {
  accessToken: string;
  refreshToken: string;
};
export type AuthenticatedResponse = {
  user: UserInfoResponse;
  allowedTenants: AllowedTenantResponse[];
  tokens: TokenResult;
  assignedFunctionalities: FunctionalityAssignment[];
  organizationAuth?: UserOrganizationAuth;
};
export type LoginRequest = {
  email: string;
  password: string;
};
export type ResetPasswordRequest = {
  recoveryToken: string;
  newPassword: string;
};
export type FunctionalityAssignmentsResponse = {
  functionality: Functionality;
  roles: UserRole[];
};
export type RenterRole = "MainRenter" | "SubRenter" | "DeactivatedRenter";
export type RenterContext = {
  buildingUnitId: string;
  role: RenterRole;
  previousRole?: RenterRole;
  revokedAt?: null | string;
};
export type RenterRoleDetails = {
  userId: string;
  isSuperAdmin: boolean;
  renterContexts: RenterContext[];
};
export type TenantUserReadModel = {
  id: string;
  firstName?: null | string;
  lastName?: null | string;
  email: string;
  role: UserRole;
};
export type TenantUserReadModelPagedListResult = {
  items: TenantUserReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type AssignTenantUserRequest = {
  role: UserRole;
};
export type UserAssignmentGlobalResult = {
  tenantName: string;
  role: UserRole;
};
export type UserState = "Unknown" | "Invited" | "Active" | "Deactivated";
export type UserGlobalReadModel = {
  id: string;
  email: string;
  firstName?: null | string;
  surname?: null | string;
  comment?: null | string;
  roles: UserAssignmentGlobalResult[];
  userState: UserState;
  isSuperAdmin?: null | boolean;
  organizationId: null | string;
  organizationName: null | string;
  organizationRole: UserOrganizationRole;
};
export type UserAssignmentRequest = {
  tenantId: string;
  role: UserRole;
};
export type UpdateUserAssignmentsRequest = {
  userAssignments: UserAssignmentRequest[];
  isGlobalUsersPage: boolean;
};
export type ChangePasswordUserRequest = {
  originalPassword: string;
  newPassword: string;
};
export type ChangeUserOrganizationRoleResponse = object;
export type ChangeUserOrganizationRoleRequest = {
  userId: string;
  role: UserOrganizationRole;
};
export type UpdateUserRequest = {
  firstName?: null | string;
  surname?: null | string;
  comment?: null | string;
};
export type OrganizationContext = {
  organizationId: string;
  organizationRole: UserOrganizationRole;
};
export type TenantContext = {
  tenantId: string;
  role: UserRole;
};
export type UserRoleDetails = {
  userId: string;
  isSuperAdmin: boolean;
  tenantContexts: TenantContext[];
};
export type UserInvitationReadModel = {
  id: string;
  email: string;
};
export type UserAutocompleteResponse = {
  userId: string;
  firstName?: null | string;
  lastName?: null | string;
  email: string;
};
export type UserGlobalReadModelPagedListResult = {
  items: UserGlobalReadModel[];
  totalItems: number;
  totalPages: number;
  page: number;
  pageSize: number;
};
export type SortGlobalUserQueryOptions = "Surname" | "Email" | "UserState";
export type SortDirection = "Ascending" | "Descending";
export type InviteUserRequest = {
  email: string;
  role: UserRole;
};
export type InviteUserGlobalRequest = {
  email: string;
  comment?: null | string;
  roles: UserAssignmentRequest[];
};
export type RegisterUserRequest = {
  firstname: string;
  surname: string;
  password: string;
};
export type UpdateUserActiveRequest = {
  isActive: boolean;
};
export type UserDetailReadModel = {
  id: string;
  tenantId: null | string;
  tenantName: null | string;
  email: string;
  firstName?: null | string;
  surname?: null | string;
  role: UserRole;
  userState: UserState;
};
export type UpdateUserProfileRequest = {
  firstName?: null | string;
  surname?: null | string;
};
export const {
  useGetApiAuthCheckSessionQuery,
  useGetApiV2AuthOrgByOrgIdCheckSessionQuery,
  usePostApiAuthForgotPasswordMutation,
  usePostApiAuthLoginMutation,
  usePostApiAuthLogoutMutation,
  usePostApiAuthRefreshTokenMutation,
  usePostApiV2AuthOrgByOrgIdRefreshTokenMutation,
  usePostApiAuthResetPasswordMutation,
  useGetApiDevelopmentFunctionalityAssignmentsQuery,
  useGetApiRentersMyRolesQuery,
  useGetApiTenantsByTenantIdUsersQuery,
  usePostApiUsersAssignmentsByUserIdMutation,
  useDeleteApiUsersAssignmentsByUserIdMutation,
  usePatchApiUsersAssignmentsByUserIdMutation,
  usePatchApiUsersChangePasswordByUserIdMutation,
  usePostApiUsersChangeOrganizationRoleByUserIdMutation,
  useDeleteApiUsersByUserIdMutation,
  useGetApiUsersByUserIdQuery,
  usePatchApiUsersByUserIdMutation,
  useGetApiUsersMyOrganizationQuery,
  useGetApiUsersMyRolesQuery,
  useGetApiUsersInvitationByInvitationTokenQuery,
  useGetApiUsersAutocompleteQuery,
  useGetApiUsersQuery,
  usePostApiUsersInviteMutation,
  usePostApiUsersInviteGlobalMutation,
  usePostApiUsersRegisterByInvitationTokenMutation,
  useDeleteApiUsersAssignmentsByTenantIdRemoveAndUserIdMutation,
  usePatchApiUsersActiveByUserIdMutation,
  usePatchApiUsersProfileMutation,
} = injectedRtkApi;
